module.exports = __webpack_public_path__ + "img/1v1_tb.49f8426f.png";